// Claude: New component for specification.md Phase 2 item 6 — systematic missing-term interface,
// Claude: letting an editor pick a language and see every wordEnglish that has an accepted entry
// Claude: elsewhere but none at all in that language (backend: /v1/missing-terms/<language>/).
// Claude: "add a selector for status as well. Keep the default to 'ACC'..." — requested directly.
// Claude: The reference status (which status counts as "has an entry elsewhere") is now also
// Claude: selectable, via the same ?status= param the backend accepts.
import React, { useState, useEffect, useContext } from "react";
import { baseUrl, getValidAccessToken } from "../shared";
import Logo from "../logo512.png";
import Navbar from "../navbar";
import Navbaranonuser from "../navbaranonuser";
import { AuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../i18n";

const MissingTerms = () => {
  const [language, setLanguage] = useState("Afr");
  const [referenceStatus, setReferenceStatus] = useState("ACC");
  const [missingTerms, setMissingTerms] = useState([]);
  const [error, setError] = useState(null);
  const { auth } = useContext(AuthContext);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchMissingTerms = async () => {
      const token = await getValidAccessToken();
      try {
        const response = await fetch(
          baseUrl + `v1/missing-terms/${language}/?status=${encodeURIComponent(referenceStatus)}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error(`HTTP status ${response.status}`);
        }
        const data = await response.json();
        setMissingTerms(data.missing_terms);
        setError(null);
      } catch (err) {
        console.error("Error:", err);
        // Claude: alpha-tester feedback — "the error message is displayed... but there is no link
        // Claude: to the login page." Same pattern UserRoleManager.js already uses.
        setError(
          <>
            Error fetching missing terms — please{' '}
            <Link to="/login" className="text-blue-500 underline hover:text-blue-700">log in</Link> again.
          </>
        );
      }
    };

    fetchMissingTerms();
  }, [language, referenceStatus]);

  return (
    <div className="min-h-screen bg-gray-100">
      {auth.userName === null && <Navbaranonuser />}
      {auth.userName != null && <Navbar />}

      <div className="flex flex-col justify-center items-center p-2">
        <h3 className="text-4xl font-bold mb-6">
          <Link to={"/"}>{t("missing_terms")}</Link>
        </h3>
        <div className="mb-4">
          <label htmlFor="missing-terms-language">{t("target_language")} </label>
          <select
            id="missing-terms-language"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
            className="border p-2 rounded-lg"
          >
            <option value="Afr">Afrikaans</option>
            <option value="Zul">isiZulu</option>
            <option value="Ses">Sesotho</option>
            <option value="Sep">Sepedi</option>
            <option value="Set">Setswana</option>
            <option value="Xit">Xitsonga</option>
            <option value="Sis">siSwati</option>
            <option value="Nde">isiNdebele</option>
            <option value="Xho">isiXhosa</option>
            <option value="Tsh">Tshivenḓa</option>
            <option value="Por">Portuguese</option>
            <option value="Fre">French</option>
          </select>
        </div>
        <div className="mb-4">
          <label htmlFor="missing-terms-status">{t("status")} </label>
          <select
            id="missing-terms-status"
            value={referenceStatus}
            onChange={(e) => setReferenceStatus(e.target.value)}
            className="border p-2 rounded-lg"
          >
            <option value="ACC">{t("accepted")}</option>
            <option value="PND">{t("pending")}</option>
            <option value="REJ">{t("rejected")}</option>
            <option value="FLG">{t("flagged")}</option>
          </select>
        </div>
        {error && <p>{error}</p>}
        {!error && missingTerms.length === 0 && <p>{t("nothing_missing")}</p>}
        <ul className="w-full max-w-2xl">
          {missingTerms.map((wordEnglish) => (
            <li
              key={wordEnglish}
              className="border border-2 rounded p-2 mb-2 flex justify-between items-center"
            >
              {wordEnglish}
              {/* Claude: new for specification.md UAT feedback — "Missing terms should include
                  buttons to initiate appropriate actions." Pre-fills AddWord.js with the target
                  language and English term via query params (see AddWord.js's useSearchParams
                  effect) rather than sending the editor to a blank form. */}
              <Link
                to={`/addword?language=${encodeURIComponent(language)}&wordEnglish=${encodeURIComponent(wordEnglish)}`}
                className="bg-cyan-700 text-white py-1 px-3 rounded-md text-sm hover:bg-cyan-800"
              >
                {t("add_translation")}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="flex flex-col justify-center items-center p-4">
        <Link to={"/"}>
          <img src={Logo} alt="Logo" width="100" height="100" />
        </Link>
      </div>
    </div>
  );
};

export default MissingTerms;
